function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "trophy-fill",
  clipPath: "url(#clip0_1988_3841)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M11.916 15.5265V17.4167H16.4994V19.25H5.49935V17.4167H10.0827V15.5265C8.31049 15.303 6.68077 14.4405 5.49935 13.1008C4.31794 11.761 3.66605 10.0362 3.66602 8.25V2.75H18.3327V8.25C18.3327 10.0362 17.6808 11.761 16.4993 13.1008C15.3179 14.4405 13.6882 15.303 11.916 15.5265ZM0.916016 4.58333H2.74935V8.25H0.916016V4.58333ZM19.2494 4.58333H21.0827V8.25H19.2494V4.58333Z",
  fill: "currentColor"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1988_3841"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "currentColor"
})));
function SvgCompetitiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitiveIcon);
export default __webpack_public_path__ + "static/media/Competitive Icon.5c3d4b79153b7947402a22432ffbab58.svg";
export { ForwardRef as ReactComponent };